import { Chip, Grid, Typography } from "@mui/material";
import React from "react";

interface Props {
    tags?: string[];
}

export function AvailableTags({ tags }: Props) {
    if (!tags?.length) return null;

    return (
        <Grid container alignItems="center" columnGap={0.5} rowGap={0.5}>
            <Grid item>
                <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ fontSize: "11px" }}
                >
                    Available tags:
                </Typography>
            </Grid>
            {tags.map((tag) => (
                <Grid item key={tag}>
                    <Chip
                        label={tag}
                        size="small"
                        variant="outlined"
                        sx={{
                            height: "20px",
                            fontSize: "11px",
                            fontFamily: "monospace",
                            "& .MuiChip-label": { px: 0.75 },
                        }}
                    />
                </Grid>
            ))}
        </Grid>
    );
}
